import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from '../src/store'
import ShardsVue from 'shards-vue'
import Socket from 'vue-loading-spinner/src/components/Socket'
import Datetime from 'vue-datetime'
import Fragment from 'vue-fragment'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'shards-ui/dist/css/shards.css'
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Fragment.Plugin)
Vue.use(Datetime)
Vue.use(ShardsVue)
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))

Vue.config.productionTip = false

Vue.component('loader', Socket)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
